export default __webpack_public_path__ + "static/media/bruno.1080e71a.jpg";